import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { forkJoin, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EnvironmentService } from 'src/app/environment/services/environment.service';
import { AuthService } from 'src/app/services/auth.service';
import { VersionService } from 'src/app/services/version.service';

@Component({
    selector: 'app-version',
    templateUrl: './version.component.html',
    styleUrls: ['./version.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VersionComponent implements OnInit {
  pVer: string;
  sVer: string;
  user: string;
  environment: string;

  unsubscribe$ = new Subject<void>();

  constructor(
    private version: VersionService,
    private auth: AuthService,
    private env: EnvironmentService,
  ) {}

  ngOnInit(): void {
    if (this.auth.authToken) {
      this.user = this.auth.username;
    }

    this.environment = this.env.environment;

    forkJoin(this.version.getPortalVersion(), this.version.getServiceVersion())
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((versions: string[]) => {
        this.pVer = versions[0];
        this.sVer = versions[1];
      });
  }
}
